import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const FlyerModalContent = () => {
  useEffect(() => {
    AOS.init({ duration: 500, once: true });
  }, []);

  return (
    <div className="mb-6 space-y-6" data-aos="fade-down">
      <h2
        className="text-2xl sm:text-3xl font-bold text-center text-gray-800"
        data-aos="fade-down"
      >
        Emotional Sobriety Workshop 23-24 August 2025
      </h2>

      <div
        className="w-full h-[400px] sm:h-[500px] overflow-hidden rounded-xl border shadow"
        data-aos="zoom-in"
      >
        <iframe
          src={`${process.env.PUBLIC_URL}/Flyers/Emotional_Sobriety_Workshop.pdf`}
          title="Emotional Sobriety Workshop Flyer"
          className="w-full h-full"
        />
      </div>

      <a
        href={`${process.env.PUBLIC_URL}/Flyers/ES-Workshop.pdf`}
        download="ES_Workshop_Flyer.pdf"
        className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 block text-center font-semibold transition"
        data-aos="fade-up"
      >
        ⬇️ Download Flyer
      </a>
    </div>
  );
};

export default FlyerModalContent;